import { useTheme } from "@/context/ThemeContext";
import { useLanguage } from "@/context/LanguageContext";
import { supportLabels } from "@/i18n";

export const PaymentDelivery = () => {
  const { theme } = useTheme();
  const { language } = useLanguage();
  const c = supportLabels(language).docGuideContent?.paymentDelivery ?? {};
  const isDark = theme === "dark";

  const section5GoodToKnow = Array.isArray(c.section5GoodToKnowList)
    ? (c.section5GoodToKnowList as string[])
    : [];

  return (
    <div className="space-y-6">
      <div>
        <h4
          className={`font-semibold mb-3 text-base ${
            isDark ? "text-white" : "text-black"
          }`}
        >
          {c.section1Title}
        </h4>
        <ul
          className={`text-sm space-y-2 ml-4 ${
            isDark ? "text-gray-300" : "text-gray-700"
          }`}
        >
          <li>• {c.section1Item1}</li>
          <li>• {c.section1Item2}</li>
          <li>• {c.section1Item3}</li>
        </ul>
      </div>

      <div>
        <h4
          className={`font-semibold mb-3 text-base ${
            isDark ? "text-white" : "text-black"
          }`}
        >
          {c.section2Title}
        </h4>
        <ul
          className={`text-sm space-y-2 ml-4 ${
            isDark ? "text-gray-300" : "text-gray-700"
          }`}
        >
          <li>• {c.section2Item1}</li>
          <li>• {c.section2Item2}</li>
          <li>• {c.section2Item3}</li>
        </ul>
        <p
          className={`text-sm mt-2 ml-4 ${
            isDark ? "text-gray-300" : "text-gray-700"
          }`}
        >
          {c.section2Note}
        </p>
      </div>

      <div>
        <h4
          className={`font-semibold mb-3 text-base ${
            isDark ? "text-white" : "text-black"
          }`}
        >
          {c.section3Title}
        </h4>
        <ul
          className={`text-sm space-y-2 ml-4 ${
            isDark ? "text-gray-300" : "text-gray-700"
          }`}
        >
          <li>• {c.section3Item1}</li>
          <li>• {c.section3Item2}</li>
          <li>• {c.section3Item3}</li>
        </ul>
        {c.section3Note ? (
          <p className={`text-xs mt-2 ml-4 ${isDark ? "text-gray-400" : "text-gray-500"}`}>
            {c.section3Note}
          </p>
        ) : null}
      </div>

      <div>
        <h4
          className={`font-semibold mb-3 text-base ${
            isDark ? "text-white" : "text-black"
          }`}
        >
          {c.section4Title}
        </h4>
        <ul
          className={`text-sm space-y-2 ml-4 ${
            isDark ? "text-gray-300" : "text-gray-700"
          }`}
        >
          <li>• {c.section4Item1}</li>
          <li>• {c.section4Item2}</li>
          <li>• {c.section4Item3}</li>
        </ul>
      </div>

      <div>
        <h4
          className={`font-semibold mb-3 text-base ${
            isDark ? "text-white" : "text-black"
          }`}
        >
          {c.section5Title}
        </h4>
        <p
          className={`text-sm mb-2 ${
            isDark ? "text-gray-300" : "text-gray-700"
          }`}
        >
          {c.section5Paragraph1}
        </p>
        <p
          className={`text-sm ${
            isDark ? "text-gray-300" : "text-gray-700"
          }`}
        >
          {c.section5Paragraph2}
        </p>
        {c.section5GoodToKnowTitle && section5GoodToKnow.length > 0 && (
          <div
            className={`mt-4 p-4 rounded-lg border ${
              isDark ? "bg-blue-950/30 border-blue-800" : "bg-blue-50 border-blue-200"
            }`}
          >
            <p
              className={`font-semibold mb-2 text-sm ${
                isDark ? "text-blue-200" : "text-blue-900"
              }`}
            >
              {c.section5GoodToKnowTitle}
            </p>
            <ul
              className={`text-sm space-y-1 ${
                isDark ? "text-blue-100" : "text-blue-800"
              }`}
            >
              {section5GoodToKnow.map((line, j) => (
                <li key={j}>• {line}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};
